import SalpBlock from './SalpBlock';

export default SalpBlock;
